// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"518":"ContactsPage","610":"BlockForContacts","789":"LoginPage","846":"RegisterPage"}[chunkId] + "." + {"518":"3ce2f75a","610":"78aa4964","789":"25dfdbe0","846":"25dfdbe0"}[chunkId] + ".chunk.css";
};